'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsersPageView = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('material-ui/styles');

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Grid = require('material-ui/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Table = require('apollo-cms/lib/DataView/List/Table');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import moment from 'moment';


var UsersPageView = exports.UsersPageView = (_temp = _class = function (_TableView) {
  _inherits(UsersPageView, _TableView);

  function UsersPageView() {
    _classCallCheck(this, UsersPageView);

    return _possibleConstructorReturn(this, (UsersPageView.__proto__ || Object.getPrototypeOf(UsersPageView)).apply(this, arguments));
  }

  _createClass(UsersPageView, [{
    key: 'getColumns',
    // static contextTypes = {
    //   ...TableView.contextTypes,
    //   UserLink: PropTypes.func.isRequired,
    // }
    value: function getColumns() {
      var UserLink = this.context.UserLink;
      return [{
        id: 'username',
        numeric: false,
        disablePadding: false,
        label: this.lexicon("User"),
        renderer: function renderer(value, record) {
          return _react2.default.createElement(UserLink, {
            user: record
          });
        }
      }];
    }
  }, {
    key: 'render',
    value: function render() {
      var Pagination = this.context.Pagination;
      var _props = this.props,
          page = _props.page,
          withPagination = _props.withPagination;
      var _props$data = this.props.data,
          objectsConnection = _props$data.objectsConnection,
          loading = _props$data.loading,
          limit = _props$data.variables.first;

      var _ref = objectsConnection || {},
          edges = _ref.edges,
          aggregate = _ref.aggregate;

      var _ref2 = aggregate || {},
          _ref2$count = _ref2.count,
          count = _ref2$count === undefined ? 0 : _ref2$count;

      if (!edges || !edges.length) {// if (loading) {
        //   return null;
        // }
        // else {
        //   return <Typography>
        //     Данные не были получены
        //   </Typography>
        // }
      }

      return _react2.default.createElement(_react.Fragment, null, _get(UsersPageView.prototype.__proto__ || Object.getPrototypeOf(UsersPageView.prototype), 'render', this).call(this), withPagination ? _react2.default.createElement(_Grid2.default, {
        container: true,
        spacing: 0
      }, edges && edges.length ? _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12
      }, _react2.default.createElement(Pagination, {
        limit: limit,
        total: count,
        page: page || 1,
        style: {
          marginTop: 20
        }
      })) : null) : null);
    }
  }]);

  return UsersPageView;
}(_Table.TableView), _class.defaultProps = _extends({}, _Table.TableView.defaultProps, {
  // listName: "companiesConnection",
  title: "Users",
  limit: 10,
  // Header,
  // Body,
  withPagination: true,
  columnData: []
}), _temp);
exports.default = (0, _styles.withStyles)(_Table.styles)(function (props) {
  return _react2.default.createElement(UsersPageView, props);
});